import { ALL_STORAGE } from '@Compute/constants'
import { getPreferZonesFromParam } from '@Compute/utils/createServer'
import { HYPERVISORS_GROUP } from '@/constants'
import i18n from '@/locales'
import { uuid } from '@/utils/utils'
import resourceViewBaremetal from './resourceViewBaremetal'
import resourceViewContainer from './resourceViewContainer'
import resourceViewServer from './resourceViewServer'
import { getServerConf } from '../utils'

export default {
  mixins: [resourceViewServer, resourceViewBaremetal, resourceViewContainer],
  data () {
    return {
      allPublic: HYPERVISORS_GROUP.public,
    }
  },
  methods: {
    getI18NValue (key, originVal) {
      if (this.$te(key)) {
        return this.$t(key)
      }
      return originVal
    },
    async getApplyMachineData () {
      try {
        const serverParam = JSON.parse(this.data.variables['server-create-paramter'] || this.data.variables.paramter || '{}')
        // 套餐
        if (serverParam.sku) {
          const skuInfo = await this.getSkuInfo(serverParam.sku)
          this.detailsData.skuInfo = skuInfo.data.data[0] || {}
        } else {
          this.detailsData.skuInfo = {}
        }
        // 区域
        const regionInfo = await this.getRegionInfo(serverParam.prefer_region || serverParam.prefer_region_id)
        this.detailsData.regionInfo = regionInfo.data || {}
        // 可用区
        const preferZoneIds = getPreferZonesFromParam(serverParam)
        if (preferZoneIds.length) {
          const zoneInfoList = await Promise.all(
            preferZoneIds.map(id => this.getZoneInfo(id).then(res => res.data || {})),
          )
          this.detailsData.zonesInfo = zoneInfoList.filter(item => item.id || item.name)
          this.detailsData.zoneInfo = zoneInfoList[0] || {}
        }
        // 镜像
        if (serverParam.disks && serverParam.disks.some(item => item.disk_type === 'sys' && item.image_id)) {
          const imageInfo = await this.getImageInfo(serverParam.disks.find(item => item.disk_type === 'sys').image_id)
          this.detailsData.imageInfo = imageInfo.data || {}
        } else if (serverParam.extraData?.image) {
          const imageInfo = await this.getImageInfo(serverParam.extraData.image)
          this.detailsData.imageInfo = imageInfo.data || {}
        }
        // ISO
        if (serverParam.cdrom) {
          const imageInfo = await this.getImageInfo(serverParam.cdrom)
          this.detailsData.isoInfo = imageInfo.data || {}
        }
        // 密钥
        if (serverParam.keypair) {
          const keypairInfo = await this.getKeypairInfo(serverParam.keypair)
          this.detailsData.keypairInfo = keypairInfo.data || {}
        }
        // 安全组
        if (serverParam.network_tags && serverParam.network_tags.length) {
          this.detailsData.networkTags = serverParam.network_tags
        } else if (serverParam.secgroups) {
          const secgroupInfo = await this.getSecgroupInfo(serverParam.secgroups)
          this.detailsData.secgroupInfo = secgroupInfo.data || {}
        }
        // 主机名
        if (serverParam.hostname) {
          this.detailsData.hostname = serverParam.hostname
        }
        // 调度策略
        if (serverParam.prefer_host) {
          const hostInfo = await this.getHostInfo(serverParam.prefer_host)
          this.detailsData.hostInfo = hostInfo.data || {}
        }
        if (serverParam.schedtags) {
          const schedtagList = await this.getSchedtagList(serverParam.schedtags.map(item => item.id))
          this.detailsData.schedtagInfo = serverParam.schedtags.map(item => {
            return {
              schedtagObj: schedtagList.data?.data?.find(i => i.id === item.id),
              strategy: item.strategy,
              ...item,
            }
          })
        }
        // 备份机
        if (serverParam.prefer_backup_host) {
          const backupHostInfo = await this.getHostInfo(serverParam.prefer_backup_host)
          this.detailsData.backupHostInfo = backupHostInfo.data || {}
        }
        this.detailsData.hypervisor = serverParam.hypervisor
        // 网络
        if (serverParam.nets && serverParam.nets.length > 0) {
          if (serverParam.nets.length === 1 && serverParam.nets[0].hasOwnProperty('exit') && !serverParam.nets[0].exit) {
            this.detailsData.networkInfo = { type: 'default' }
          } else if (serverParam.nets[0].network && serverParam.extraData?.nets?.length && serverParam.extraData.nets[0].vpc) {
            const vpcInfo = await this.getVpcInfo(serverParam.extraData.nets[0].vpc)
            this.detailsData.vpcInfo = vpcInfo.data || {}
            const networkList = await this.getNetworkList(serverParam.nets.map(item => item.network))
            this.detailsData.networkInfo = {
              type: 'manual',
              networkList: this.mergeWorkflowNetworkList(serverParam.nets, networkList, serverParam.extraData?.nets),
            }
          } else if (serverParam.nets[0].network && serverParam.extraData?.extraNets?.length) {
            // 裸金属：vpc 在 extraData.extraNets
            const vpcId = serverParam.extraData.extraNets[0]?.vpc
            if (vpcId) {
              const vpcInfo = await this.getVpcInfo(vpcId)
              this.detailsData.vpcInfo = vpcInfo.data || {}
            }
            const networkList = await this.getNetworkList(serverParam.nets.map(item => item.network).filter(Boolean))
            this.detailsData.networkInfo = {
              type: 'manual',
              networkList: this.mergeWorkflowNetworkList(serverParam.nets, networkList, serverParam.extraData?.extraNets),
            }
          } else if (serverParam.nets[0].network) {
            const networkList = await this.getNetworkList(serverParam.nets.map(item => item.network).filter(Boolean))
            this.detailsData.networkInfo = {
              type: 'manual',
              networkList: this.mergeWorkflowNetworkList(serverParam.nets, networkList, serverParam.extraData?.nets),
            }
          } else if (serverParam.nets[0].schedtags) {
            const schedtagList = await this.getSchedtagList(serverParam.nets.map(item => item.schedtags && item.schedtags.length && item.schedtags[0].id))
            this.detailsData.networkInfo = {
              type: 'schedtag',
              schedtagList: serverParam.nets.map(item => {
                return {
                  schedtagObj: schedtagList.data?.data?.find(i => i.id === item.schedtags[0].id),
                  strategy: item.schedtags[0].strategy,
                  ...item,
                }
              }),
            }
          }
        }
        // 反亲和组
        if (serverParam.groups) {
          const groupInfo = await this.getGroupInfo(serverParam.groups)
          this.detailsData.groupInfo = groupInfo.data?.data || []
        }
        // 主机加密
        if (serverParam.encrypt_key_id) {
          const encryptKeyInfo = await this.getEncryptKeyInfo(serverParam.encrypt_key_id)
          this.detailsData.encryptKeyInfo = encryptKeyInfo.data || {}
        }
      } catch (error) {
        this.$notification.error({
          message: i18n.t('common_426'),
          description:
            i18n.t('common_427'),
        })
        this.loaded = true
        // throw error
      }
    },
    formatRegionZone (row) {
      const region = row.regionInfo && this._$t(row.regionInfo)
      const zones = row.zonesInfo?.length
        ? row.zonesInfo
        : (row.zoneInfo?.name ? [row.zoneInfo] : [])
      if (zones.length) {
        const zoneNames = zones.map(item => this._$t(item)).filter(Boolean).join('、')
        return region ? `${region} ${zoneNames}` : zoneNames
      }
      return region || '-'
    },
    initResourceViewInfo () {
      const resourceType = this.getResourceType(this.detailsData)
      if (resourceType === 'baremetal') {
        this.initBaremetalInfo()
      } else if (resourceType === 'server_container') {
        this.initServerContainerInfo()
      } else {
        this.initServerInfo()
      }
    },
    /** 合并工单 nets 与网络详情；保留每卡 port_mappings */
    mergeWorkflowNetworkList (nets = [], networkListRes, extraNets = []) {
      const list = networkListRes?.data?.data || []
      return nets.map((item, index) => {
        const networkObj = list.find(i => i.id === item.network || i.name === item.network)
        const fromExtra = extraNets[index]
        const port_mappings = (item.port_mappings?.length ? item.port_mappings : null) ||
          (fromExtra?.port_mappings?.length ? fromExtra.port_mappings : null) ||
          item.port_mappings
        return {
          ...item,
          ...(port_mappings ? { port_mappings } : {}),
          networkObj,
        }
      })
    },
    formatWorkflowPortMapping (pm = {}) {
      const hostPort = (pm.host_port != null && pm.host_port !== '')
        ? pm.host_port
        : this.$t('compute.automatic_allocation')
      const proto = pm.protocol ? ` (${String(pm.protocol).toUpperCase()})` : ''
      return `${this.$t('compute.repo.container_port')}: ${pm.port} = ${this.$t('compute.repo.host_port')}: ${hostPort}${proto}`
    },
    renderWorkflowPortMappings (portMappings = [], { nicIndex, multiNic } = {}) {
      if (!Array.isArray(portMappings) || !portMappings.length) return []
      return portMappings.map((pm) => {
        const prefix = multiNic ? `${this.$t('compute.text_193')}${nicIndex} ` : ''
        return (
          <div>{prefix}{this.formatWorkflowPortMapping(pm)}</div>
        )
      })
    },
    renderWorkflowNetworkInfo () {
      const networkInfo = this.detailsData.networkInfo || {}
      if (!networkInfo.type) return '-'
      const ret = []
      if (networkInfo.type === 'default') {
        return this.$t('common_498')
      } else if (networkInfo.type === 'manual') {
        ret.push(<div>{this.$t('compute.text_2')}</div>)
        const multi = (networkInfo.networkList || []).length > 1
        networkInfo.networkList.forEach((item, index) => {
          const label = multi ? `${this.$t('compute.text_193')}${index}: ` : ''
          if (item.networkObj?.id) {
            const netInfoList = []
            const {
              guest_ip_start,
              guest_ip_end,
              guest_ip_mask,
              guest_ip6_start,
              guest_ip6_end,
              guest_ip6_mask,
              vlan_id,
            } = item.networkObj
            if (guest_ip_start && guest_ip_end) {
              netInfoList.push(`${guest_ip_start}-${guest_ip_end}/${guest_ip_mask}`)
            }
            if (guest_ip6_start && guest_ip6_end) {
              netInfoList.push(`${guest_ip6_start}-${guest_ip6_end}/${guest_ip6_mask}`)
            }
            if (vlan_id) {
              netInfoList.push(`vlan=${vlan_id}`)
            }
            ret.push(<div>{label}{item.networkObj.name} ({netInfoList.join(',')})</div>)
          } else {
            ret.push(<div>{label}{item.network || item.id}</div>)
          }
          ret.push(...this.renderWorkflowPortMappings(item.port_mappings, { nicIndex: index, multiNic: multi }))
        })
      } else if (networkInfo.type === 'schedtag') {
        ret.push(<div>{this.$t('compute.text_3')}</div>)
        const multi = (networkInfo.schedtagList || []).length > 1
        networkInfo.schedtagList.forEach((item, index) => {
          const label = multi ? `${this.$t('compute.text_193')}${index}: ` : ''
          if (item.schedtagObj?.id) {
            const strategy = item.strategy
              ? ` ${this.$te(`schedtagPolicys.${item.strategy}`) ? this.$t(`schedtagPolicys.${item.strategy}`) : item.strategy}`
              : ''
            ret.push(<div>{label}{item.schedtagObj.name}{strategy}</div>)
          } else {
            ret.push(<div>{label}{item.schedtag || item.id}</div>)
          }
        })
      }
      return ret.length ? ret : '-'
    },
    getResourceType (row) {
      const serverConf = getServerConf(row || this.detailsData)
      if (serverConf.extraData?.__resource_type__) {
        return serverConf.extraData.__resource_type__
      }
      return ''
    },

    getSkuInfo (name) {
      const params = { name: name, limit: 1 }
      if (this.allPublic[this.data.hypervisor]) {
        params.public_cloud = true
      }
      return new this.$Manager('serverskus').list({ params })
    },
    getKeypairInfo (keypair) {
      return new this.$Manager('keypairs').get({ id: keypair })
    },
    getVpcInfo (vpc) {
      return new this.$Manager('vpcs').get({ id: vpc })
    },
    /**
     * 按 id 逐个拉取网络详情。
     * 必须带不同 $t：同 url+method 的 list 会被 http 层 cancel，多网卡只剩最后一次。
     */
    async getNetworkList (networks) {
      const ids = (networks || []).filter(Boolean)
      if (!ids.length) return { data: { data: [] } }
      const data = await Promise.all(ids.map((id, idx) => {
        return new this.$Manager('networks').get({
          id,
          params: { $t: `workflow-network-${id}-${idx}-${uuid(6)}` },
        }).then(res => res.data).catch(() => null)
      }))
      return { data: { data: data.filter(Boolean) } }
    },
    getSchedtagList (schedtags) {
      const ids = (schedtags || []).filter(Boolean)
      return new this.$Manager('schedtags').list({
        params: {
          filter: `id.in(${ids.map(item => `'${item}'`).join(',')})`,
          $t: `workflow-schedtag-${uuid(6)}`,
        },
      })
    },
    getRegionInfo (region) {
      return new this.$Manager('cloudregions').get({ id: region })
    },
    getZoneInfo (zone) {
      return new this.$Manager('zones').get({ id: zone })
    },
    getHostInfo (host) {
      return new this.$Manager('hosts').get({ id: host })
    },
    getEncryptKeyInfo (encryptKey) {
      return new this.$Manager('encryptkeys').get({ id: encryptKey })
    },
    getSecgroupInfo (secgroups) {
      const params = {
        scope: this.$store.getters.scope,
      }
      secgroups.forEach((id, idx) => {
        params[`id.${idx}`] = id
      })
      return new this.$Manager('secgroups').list({
        params,
      })
    },
    getProcessInstance (pid) {
      return new this.$Manager('historic-process-instances', 'v1').get({ id: pid })
    },
    getServerInfo (serverIds) {
      if (!Array.isArray(serverIds)) {
        serverIds = [serverIds]
      }
      return new this.$Manager('servers').list({ filter: `id.in(${serverIds.join(',')})` })
    },
    async getImageInfo (image) {
      if (!image) return {}
      const imageInfo = await new this.$Manager('images').get({ id: image }).catch(() => {})
      if (imageInfo) {
        return imageInfo || {}
      }
      const cacheImageInfo = await new this.$Manager('cachedimages').get({ id: image }).catch(() => {})
      if (cacheImageInfo) {
        return cacheImageInfo || {}
      }
      return {}
    },
    getGroupInfo (groups) {
      return new this.$Manager('instancegroups').list({ params: { filter: `id.in(${groups.join(',')})` } })
    },
    initDeleteServeInfo (variables) {
      let servers = JSON.parse(variables.parameter)
      if (servers.length === 0) {
        this.fetchServerInfo(variables.ids || [])
          .then((res) => {
            servers = res.data
            this.deleteServers = servers
          })
      } else {
        this.deleteServers = servers
      }
    },
    getDiskInfo (row, serverConf) {
      const sdiks = serverConf.disks
      if (!sdiks) return {}
      const dataDisk = {}
      const sysDisk = {}
      let image = '-'
      const sysDisks = sdiks.filter(v => v.disk_type === 'sys')
      const dataDisks = sdiks.filter(v => v.disk_type !== 'sys')
      if (sysDisks && sysDisks.length > 0) {
        const sysKey = sysDisks[0].backend || 'local'
        image = sysDisks[0].image || sysDisks[0].image_id || '-'
        sysDisk[sysKey] = this._dealSize(sysDisks)
      }
      if (dataDisks && dataDisks.length > 0) {
        const NEW_ALL_STORAGE = { ...ALL_STORAGE }
        dataDisks.forEach((item) => {
          if (!ALL_STORAGE[item.backend]) {
            NEW_ALL_STORAGE[item.backend] = {
              label: item.backend,
              max: 500,
              min: 1,
              sysMax: 500,
              sysMin: 10,
              value: item.backend,
            }
          }
        })
        for (const k in NEW_ALL_STORAGE) {
          const e = NEW_ALL_STORAGE[k] || { key: k, value: k }
          const sameType = dataDisks.filter(v => (v.backend || 'local') === e.value)
          if (sameType && sameType.length) {
            dataDisk[k] = this._dealSize(sameType)
          }
        }
      }
      if (serverConf.cdrom && dataDisks.length > 0) {
        image = dataDisks[0].image
      }
      return {
        sysDisk: this._diskStringify(sysDisk) || '-',
        dataDisk: this._diskStringify(dataDisk) || '-',
        image,
      }
    },
    _diskStringify (diskObj) {
      let str = ''
      const storageArr = Object.values(ALL_STORAGE)
      for (const k in diskObj) {
        const num = diskObj[k]
        const disk = storageArr.find(v => v.value === k)
        if (disk) {
          str += `、${parseInt(num / 1024)}GB（${disk.label}）`
        } else {
          str += `、${parseInt(num / 1024)}GB（${k}）`
        }
      }
      return str.slice(1)
    },
    _dealSize (sameType) {
      const sameType1 = sameType.map(v => {
        const size = +v.size
        return size
      })
      return sameType1.reduce((a, b) => {
        return a + b
      })
    },
  },
}
